(() => {
  'use strict';

  function enhanceGallery(gallery) {
    if (gallery.dataset.rvGalleryReady === 'true') return;
    const track = gallery.querySelector('[data-rv-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-rv-gallery-slide]')];
    const thumbnails = [...gallery.querySelectorAll('[data-rv-gallery-thumbnail]')];
    const controls = gallery.querySelector('[data-rv-gallery-controls]');
    const previous = gallery.querySelector('[data-rv-gallery-previous]');
    const next = gallery.querySelector('[data-rv-gallery-next]');
    const position = gallery.querySelector('[data-rv-gallery-position]');
    const caption = gallery.querySelector('[data-rv-gallery-current-caption]');
    const thumbnailRail = gallery.querySelector('.rv-gallery-thumbnails');
    if (!track || !slides.length || slides.length !== thumbnails.length || !controls || !previous || !next || !position || !caption) return;

    let current = 0;
    let scrollTimer;
    const clamp = index => Math.max(0, Math.min(slides.length - 1, index));
    const leftFor = index => slides[index].offsetLeft - slides[0].offsetLeft;

    function update(index) {
      current = clamp(index);
      if (slides.some((slide, i) => i !== current && slide.contains(document.activeElement))) track.focus({preventScroll: true});
      thumbnails.forEach((thumbnail, i) => thumbnail.setAttribute('aria-pressed', String(i === current)));
      slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== current));
        slide.querySelectorAll('a').forEach(link => { link.tabIndex = i === current ? 0 : -1; });
      });
      previous.disabled = current === 0;
      next.disabled = current === slides.length - 1;
      position.textContent = `${current + 1} of ${slides.length}`;
      caption.textContent = slides[current].querySelector('figcaption')?.textContent.trim() || '';
      if (thumbnailRail?.clientWidth) {
        const left = Math.max(0, thumbnails[current].offsetLeft - 2);
        const right = thumbnails[current].offsetLeft + thumbnails[current].offsetWidth + 2;
        if (left < thumbnailRail.scrollLeft) thumbnailRail.scrollTo({left, behavior: 'auto'});
        else if (right > thumbnailRail.scrollLeft + thumbnailRail.clientWidth) thumbnailRail.scrollTo({left: right - thumbnailRail.clientWidth, behavior: 'auto'});
      }
    }

    function show(index, smooth = true) {
      update(index);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({left: leftFor(current), behavior: smooth && !reduceMotion ? 'smooth' : 'auto'});
    }

    function syncFromScroll() {
      let nearest = 0;
      let distance = Infinity;
      slides.forEach((slide, i) => {
        const candidate = Math.abs(leftFor(i) - track.scrollLeft);
        if (candidate < distance) {
          nearest = i;
          distance = candidate;
        }
      });
      if (nearest !== current) update(nearest);
    }

    previous.addEventListener('click', () => show(current - 1));
    next.addEventListener('click', () => show(current + 1));
    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => show(index)));

    gallery.addEventListener('keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      let target;
      if (event.key === 'ArrowLeft') target = current - 1;
      else if (event.key === 'ArrowRight') target = current + 1;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = slides.length - 1;
      else return;
      event.preventDefault();
      const fromSlide = event.target.closest('[data-rv-gallery-slide]');
      show(target);
      if (event.target.closest('[data-rv-gallery-thumbnail]')) thumbnails[current].focus({preventScroll: true});
      else if (fromSlide) slides[current].querySelector('a')?.focus({preventScroll: true});
    });

    // Native touch scrolling preserves vertical page gestures and pinch zoom.
    // Sync after scrolling settles, including browser-managed scroll snapping.
    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(syncFromScroll, 140);
    }, {passive: true});
    track.addEventListener('scrollend', () => {
      window.clearTimeout(scrollTimer);
      syncFromScroll();
    });

    update(0);
    gallery.dataset.rvGalleryReady = 'true';
    controls.hidden = false;
    caption.hidden = false;

    if ('ResizeObserver' in window) {
      let width = track.clientWidth;
      const observer = new ResizeObserver(() => {
        if (!track.clientWidth || track.clientWidth === width) return;
        width = track.clientWidth;
        show(current, false);
      });
      observer.observe(track);
    }
  }

  function init(scope) {
    if (scope.matches?.('[data-rv-gallery]')) enhanceGallery(scope);
    scope.querySelectorAll('[data-rv-gallery]').forEach(enhanceGallery);
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
